import { CircleCheck } from 'lucide-react';
import formatPhone from '../utils/formatPhoneForUser';
import { Button } from './ui/button';
import { Info, ChevronLeft } from 'lucide-react';

export function SubmissionMessage(props) {
	return (
		<div className="flex flex-col text-center items-center justify-items-center">
			{props.apiError ? (
				<div className='flex flex-col items-center my-2'>
					<Info color={props.errorColor} size={90} />
					<h1 className="font-semibold py-4 text-4xl">
						{props.apiErrorMessage
							? props.apiErrorMessage
							: 'Server error! Please try again in a few minutes.'}
					</h1>
					<Button
						variant="ghost"
						onClick={() => {
							props.resetInputs();
							props.setIsSubmitted(false);
						}}
					>
						<ChevronLeft />
						Go back
					</Button>
				</div>
			) : (
				<div className="flex flex-col items-center my-2">
					<CircleCheck color="green" size={90} />
					<h1 className="md:text-8xl font-extrabold text-7xl">
						Thank You
					</h1>

					<p className=" md:text-lg text-base py-2">
						You should receive a text from +1{' '}
						{formatPhone(props.twilioNumber)}
					</p>
					<Button
						variant="ghost"
						onClick={() => {
							props.resetInputs();
							props.setIsSubmitted(false);
						}}
						style={{ textTransform: 'none' }}
					>
						Don't see a text? Click here to try again.
					</Button>
				</div>
			)}
		</div>
	);
}

export default SubmissionMessage;
